import script from "./RequestDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDetails.vue?vue&type=script&setup=true&lang=js"

import "./RequestDetails.vue?vue&type=style&index=0&id=ad08b0ea&lang=css"
import "./RequestDetails.vue?vue&type=style&index=1&id=ad08b0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad08b0ea"]])

export default __exports__